module.exports = __webpack_public_path__ + "static/kt-d8b2fcc9ee0779e6355cef1963e4327a.jpg";